module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.2d0bdc8d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/OpenSans/OpenSans-Light.ttf
// module id = 310
// module chunks = 0